import { DocumentModuleEnum } from "shared/enums/document-module-enum";
import { documentReviewPeriodDisplay, DocumentReviewPeriodEnum } from "shared/enums/document-review-period-enum";
import { isoDateStringToBrowserSafeString } from "../mapping/mapping";
import { RelatedDocument } from "./related-document";
import { RulebookModeEnum } from 'shared/enums/rulebook-mode-enum';
import { DocumentDepartmentModel } from "../api/models";
import { User } from "../../services/reportingApi";


export interface Document {
    documentId?: number,
    typeLabel?: string,
    subTypeLabel?: string | null,
    documentModule?: DocumentModuleEnum,
    typeId?: number,
    subTypeId?: number,
    title?: string,
    documentNumber?: string,
    versionNumber?: string,
    effectiveFromDate?: string,
    effectiveFromTime?: string,
    expiryDate?: string,
    expiryTime?: string,
    reviewPeriod?: DocumentReviewPeriodEnum,
    reviewRecurring?: boolean,
    notifyUsers?: boolean,
    releaseNotes?: string,
    rescindDocumentReason?: string,
    file?: File,
    fileName?: string,
    publishDate?: string,
    publishTime?: string,
    requiresAcknowledgementAndNotify?: boolean,
    relatedDocuments?: Array<RelatedDocument>,
    canEdit?: boolean,
    acknowledgeRequired?: boolean,
    rulebookOperatingSystem?: RulebookModeEnum,
    departments?: DocumentDepartmentModel[],
    departmentNames?: string[],
    department?: string,
    departmentTeams?: string[],
    personnelId?: number[],
    personnel?: User[]
}

type IDocumentDisplayProps = {
    effectiveFromDateDisplay: string,
    expiryDateDisplay: string,
    publishDateDisplay: string,
    reviewPeriodDisplay: string
}

export type IDocumentDisplay = IDocumentDisplayProps & Document;

export const toDisplayDocument = (d: Document): IDocumentDisplay => {
  
    var dateTimeFormat = new Intl.DateTimeFormat("en-AU", {});
    var effectiveFromDate = d.effectiveFromDate ? new Date(isoDateStringToBrowserSafeString(`${d.effectiveFromDate} ${d.effectiveFromTime || '00:00'}`)) : undefined;
    var expiryDateDate = d.expiryDate ? new Date(isoDateStringToBrowserSafeString(`${d.expiryDate} ${d.expiryTime || '00:00'}`)) : undefined;
    var publishDateDate = d.publishDate ? new Date(isoDateStringToBrowserSafeString(`${d.publishDate} ${d.publishTime || '00:00'}`)) : undefined;
    var reviewPeriodDisplay = `${documentReviewPeriodDisplay(d.reviewPeriod)}` + `${(d.reviewRecurring ? " recurring" : "")}`;
    return {
        ...d,
        effectiveFromDateDisplay: effectiveFromDate ? dateTimeFormat.format(effectiveFromDate) : '',
        expiryDateDisplay: expiryDateDate ? dateTimeFormat.format(expiryDateDate) : '',
        publishDateDisplay: publishDateDate ? dateTimeFormat.format(publishDateDate) : '',
        reviewPeriodDisplay: `${reviewPeriodDisplay}`
    }
}
